import { Skeleton } from '@/components/ui/skeleton';

export function LotSizingSupplierTableLineSkeleton() {
  return (
    <div className='rounded-md border bg-background p-4'>
      <div className='flex items-center gap-3'>
        <Skeleton className='h-4 w-4 shrink-0' />
        <Skeleton className='h-4 w-32' />
        <Skeleton className='h-4 w-16' />
        <div className='flex flex-1 justify-end gap-3'>
          <Skeleton className='h-4 w-20' />
          <Skeleton className='h-4 w-20' />
        </div>
      </div>
    </div>
  );
}
